import { render, staticRenderFns } from "./FreeBox.vue?vue&type=template&id=269b7af0&"
import script from "./FreeBox.vue?vue&type=script&lang=ts&"
export * from "./FreeBox.vue?vue&type=script&lang=ts&"
import style0 from "./FreeBox.vue?vue&type=style&index=0&id=269b7af0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports